(() => {
  let committing = false;

  const isMobileDrawerOpen = () => {
    const sidebar = document.querySelector('sidebar-filters-mobile');
    return !!sidebar && sidebar.classList.contains('is-opened');
  };

  const shouldSuppress = () => isMobileDrawerOpen() && !committing;

  const patchShop = (shop) => {
    if (!shop || shop.dataset.mobileBatchPatched) return;
    shop.dataset.mobileBatchPatched = 'true';

    const originalUpdateShop = shop.updateShop.bind(shop);
    const originalUpdateURL = shop.updateURL.bind(shop);

    shop.updateShop = (url) => {
      if (shouldSuppress()) return;
      return originalUpdateShop(url);
    };

    shop.updateURL = (searchParams, url) => {
      if (shouldSuppress()) return;
      return originalUpdateURL(searchParams, url);
    };
  };

  const init = () => patchShop(document.querySelector('shop-component'));

  document.addEventListener(
    'click',
    (event) => {
      if (!event.target.closest('sidebar-filters-mobile filters-submit-btn')) return;
      committing = true;
      setTimeout(() => {
        committing = false;
      }, 0);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
